export default __webpack_public_path__ + "static/02-02-writing-note-taking-f686044eeb1e60543c7630c2a05fa66c.mp4";